/**
 * Created by bob.gear on 09/04/2015.
 */
//-------------------------------------------------------------------------
// Create Project Watch Controller
//-------------------------------------------------------------------------


angular.module('EICDataStream3.notificationCentre')
  .controller('CreateProjectWatchController', ['$scope',
    '$state',
    '$uibModalInstance',
    'watchService',
    'trackingStatusService',
    'data',
    function ($scope, $state, $uibModalInstance, watchService, trackingStatusService, data) {

      $scope.componentName = "CreateProjectWatchController";
      $scope.trackingStatusService = trackingStatusService;

      $scope.projectWatchParams = data.projectWatchParams;

      $scope.projectWatchParams.watchCategories = [
        {name:"Contracting", isChecked:false}  ,
        {name:"Developmentt", isChecked:false}  ,
        {name:"Planning", isChecked:false}  ,

      ];

      $scope.projectWatchParams.newWatch = true;
      $scope.selectedProjectWatches = [];

      $scope.getSelectedProjectWatches =  function() {
        var watches = watchService.getWatches()
          .then(function(response) {
            for (let i = 0; i < response.data.length; i++) {
              var thisItem = response.data[i];
              if (thisItem.watchType == 1) {
                $scope.selectedProjectWatches.push(thisItem);
              }
            }

          }, errorCallback);
      }();

      $scope.createProjectWatch =  function() {
        $scope.projectWatchParams.selectedTrackingStatuses = trackingStatusService.selectedValues;
        var watch = watchService.createProjectWatch($scope.projectWatchParams)
                                .then(successCallback, errorCallback);
      };

      $scope.addProjectsToSelectedWatch =  function(){
        watchService.addProjectsToWatch($scope.projectWatchParams)
          .then(successCallback, errorCallback);

      };


      $scope.$watch("projectWatchParams.newWatch", function(newVal, oldVal) {

        if (newVal) {
          // clear the select list and description
          // to prepare for a new watch
          $scope.projectWatchParams.selectedProjectWatch = null;
          $scope.projectWatchParams.description = "";
        }
        else {
          // clear the text name
          $scope.projectWatchParams.title = "";
        }
      });

      $scope.$watch("projectWatchParams.selectedProjectWatch", function(newVal, oldVal) {
        if (!newVal) return;

        // when a watch is selected, populate the description
        $scope.projectWatchParams.description = $scope.projectWatchParams.selectedProjectWatch.description;

      });


      $scope.formInvalid = function() { //$scope.watchDialog.$dirty &&
        return ($scope.watchDialog.$invalid);
      };

      var selectCategories = function(){
        return ($scope.projectWatchParams.watchCategories != 'any');
      };

      var formPristine = function() {
        return $scope.watchDialog.$pristine;
      };

      var categoriesFormPristine = function() {
        return $scope.watchCategoriesForm.$pristine;
      };

      var allCategoriesValid = function(list){
        var count = 0;

        for(var i=0; i<$scope.projectWatchParams.watchCategories.length; i++){
          if($scope.projectWatchParams.watchCategories[i].isChecked)
          count++;
        }
        return (count > 0) || $scope.watchCategoriesForm.$pristine ;
      };

      var successCallback = function(response){
        $scope.success = true;
        $scope.requestSent = true;

        $scope.message = response.statusText;
        $scope.requestSentCloseButtonCaption = "OK";
        $scope.messageStyle = {'color':'black'};
      };

      var errorCallback = function (response) {
        $scope.success = false;
        $scope.requestSent = true;

        $scope.message = response.statusText;
        $scope.requestSentCloseButtonCaption = "Cancel";
        $scope.messageStyle = {'color': 'red'};
      };

      $scope.viewWatches = function(){

        $state.go("notificationCentre");

      };

      $scope.cancel = function(){
        $uibModalInstance.dismiss('Canceled');
      }; // end cancel

      $scope.hitEnter = function(evt){
        if(angular.equals(evt.keyCode,13) && !(angular.equals($scope.user.name,null) || angular.equals($scope.user.name,'')))
          $scope.save();

      };

    }]);


